import * as yup from 'yup';

import i18n from '@app/i18n/config';

import { TypesSelfEmployment } from './types';

const stringSchema = yup
  .string()
  .required(i18n.t('COMMON:errors.requiredField'));

export const selfEmploymentFormSchema = yup
  .object()
  .shape({
    activity: stringSchema,
    description: yup.string().when('activity', {
      is: TypesSelfEmployment.OTHER,
      then: () =>
        yup
          .string()
          .required(
            i18n.t(
              'REGISTRATION_QUESTIONARY:selfEmploymentStatusForm.errors.otherActivityInput'
            )
          ),
    }),
  })
  .required();
